import React, { useRef } from 'react';

const DIRS = ['North', 'North-East', 'East', 'South-East', 'South', 'South-West', 'West', 'North-West'];

export const facingFromAngle = (angle) => DIRS[Math.round(((Number(angle) || 0) % 360) / 45) % 8];

export const CompassPicker = ({ angle, onChange }) => {
  const ref = useRef(null);
  const a = Number(angle) || 0;
  const rad = ((a - 90) * Math.PI) / 180;

  const pick = (e) => {
    const box = ref.current.getBoundingClientRect();
    const dx = e.clientX - (box.left + box.width / 2);
    const dy = e.clientY - (box.top + box.height / 2);
    let deg = (Math.atan2(dy, dx) * 180) / Math.PI + 90;
    if (deg < 0) deg += 360;
    onChange(Math.round(deg));
  };

  return (
    <div className="flex items-center gap-4" data-testid="compass-picker">
      <svg ref={ref} onClick={pick} width="132" height="132" viewBox="0 0 132 132"
        className="cursor-crosshair rounded-full border border-slate-200 bg-white dark:border-slate-700 dark:bg-slate-900"
        data-testid="compass-dial">
        <circle cx="66" cy="66" r="58" fill="none" stroke="currentColor" strokeOpacity="0.15" />
        {DIRS.map((d, i) => {
          const r = ((i * 45 - 90) * Math.PI) / 180;
          return <text key={d} x={66 + 50 * Math.cos(r)} y={70 + 50 * Math.sin(r)} textAnchor="middle"
            className="fill-current text-[9px] opacity-60">{d.split('-').map((p) => p[0]).join('')}</text>;
        })}
        <line x1="66" y1="66" x2={66 + 44 * Math.cos(rad)} y2={66 + 44 * Math.sin(rad)}
          stroke="#f59e0b" strokeWidth="3" strokeLinecap="round" />
        <circle cx="66" cy="66" r="4" fill="#f59e0b" />
      </svg>
      <div className="space-y-2 text-sm">
        <div>
          <label className="mb-1 block text-xs font-medium">Bearing (°)</label>
          <input type="number" min="0" max="359" value={a} data-testid="compass-angle-input"
            onChange={(e) => onChange(Math.max(0, Math.min(359, Number(e.target.value) || 0)))}
            className="w-24 rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm dark:border-slate-700 dark:bg-slate-900" />
        </div>
        <p className="text-xs text-muted-foreground">Facing <span className="font-medium" data-testid="compass-readable">{facingFromAngle(a)}</span> ({a}°)</p>
      </div>
    </div>
  );
};

export default CompassPicker;
